export default {
  SET_CATEGORY_PRODUCTS (state, category_products) {
    state.category_products = category_products
  },
  REMOVE_RECORD (state, itemId) {
    const categoryProductIndex = state.category_products.findIndex((u) => u.id === itemId)
    state.category_products.splice(categoryProductIndex, 1)
  }
}
